import { Button, Box } from "@mui/material";
import { tabStyle, tabContainerStyle } from "./TabStyles";

const TabsComponent = ({ tabs, selected, onSelect }) => (
  <Box sx={tabContainerStyle}>
    {tabs.map(tab => (
      <Button
        key={tab.value}
        sx={tabStyle(selected === tab.value)}
        onClick={() => onSelect(tab.value)}
        disableRipple
      >
        {tab.label}
      </Button>
    ))}
  </Box>
);

export default TabsComponent;